import {
  Box,
  Button,
  FormControl,
  FormLabel,
  Input,
  Text
} from "@chakra-ui/react";
import { Project, ProjectCategory } from "models/project_type";
import { MdLock } from "react-icons/md";
import InputMask from "react-input-mask";
import formatNumber from "views/admin/order/hooks/formatNumber";
import ItemTableProject from "./ItemTable";

interface IFinanceProjectCategory {
  item: ProjectCategory;
  index: number;
  lockItem: (item: ProjectCategory) => void;
  reducaoGrupo: (item: ProjectCategory, value: string) => void;
  manejoGrupo: (item: ProjectCategory, value: string) => void;
  borderColor: string;
  changeItem: (item: ProjectCategory) => void;
  accountSelected: Project;
  calcula : () => void;
  calculaManejo : () => void;
}

const FinanceProjectCategory = ({
  index,
  item,
  lockItem,
  reducaoGrupo,
  manejoGrupo,
  borderColor,
  changeItem,
  accountSelected,
  calcula,
  calculaManejo
}: IFinanceProjectCategory) => {
  return (
    <Box key={`${item.id}-${index}`} mb={16}>
      <Box flex="1" flexDirection={"row"}>
        <Text
          textAlign="left"
          color={"#422AFB"}
          fontWeight={"bold"}
          fontSize={24}
        >
          {index + 1} - {item.descricao} - subtotal :{" "}
          {formatNumber(Number(item.valor))}
        </Text>

        <Button
          leftIcon={<MdLock />}
          colorScheme={item.travado ? "red" : "green"}
          variant="solid"
          float={"right"}
          mt={7}
          ml={8}
          onClick={() => {
            lockItem(item);
          }}
        >
          {item.travado ? "Liberar Grupo" : "Travar Grupo"}
        </Button>

        <FormControl float={"right"} w={48}  ml={4}>
          <FormLabel
            display="flex"
            ms="4px"
            fontSize="sm"
            fontWeight="bold"
            color={"black"}
            mb="8px"
          >
            Valor Reduzido Grupo
          </FormLabel>

          <Input
            isRequired={true}
            fontSize="sm"
            ms={{ base: "0px", md: "0px" }}
            type="text"
            placeholder="Valor Reduzido Grupo"
            fontWeight="500"
            size="md"
            value={formatNumber(Number(item.valorReducao))}
            disabled={item.travado}
          />
        </FormControl>

        <FormControl float={"right"} w={48}>
          <FormLabel
            display="flex"
            ms="4px"
            fontSize="sm"
            fontWeight="bold"
            color={"black"}
            mb="8px"
          >
            Redução por Grupo (%)
          </FormLabel>

          <Input
            isRequired={true}
            fontSize="sm"
            value={item.porcentagemReducao}
            ms={{ base: "0px", md: "0px" }}
            type="text"
            placeholder="Redução por Grupo (%)"
            fontWeight="500"
            size="md"
            as={InputMask}
            onChange={
                (e) => {
                    if(e.target.value.length > 4 && e.target.value !== '__.__') {     
                        reducaoGrupo(item, e.target.value);
                    }
                }
            }
            onBlur={(e) => {
              reducaoGrupo(item, e.target.value);
            }}
            mask={"99.99"}
            disabled={item.travado}
          />
        </FormControl>

        <FormControl float={"right"} w={48} mr={4}>
          <FormLabel
            display="flex"
            ms="4px"
            fontSize="sm"
            fontWeight="bold"
            color={"black"}
            mb="8px"
          >
            Valor Manejo
          </FormLabel>

          <Input
            isRequired={true}
            fontSize="sm"
            ms={{ base: "0px", md: "0px" }}
            type="text"
            placeholder="Valor Manejo"
            fontWeight="500"
            size="md"
            value={formatNumber(Number(item.valorManejo))}
            disabled={item.travado}
          />
        </FormControl>

        <FormControl float={"right"} w={56} mr={4}>
          <FormLabel
            display="flex"
            ms="4px"
            fontSize="sm"
            fontWeight="bold"
            color={"black"}
            mb="8px"
          >
            Limite de Manejo por Grupo (%)
          </FormLabel>

          <Input
            value={item.porcentagemManejo}
            isRequired={true}
            fontSize="sm"
            ms={{ base: "0px", md: "0px" }}
            type="text"
            placeholder=" Limite de Manejo por Grupo (%)"
            fontWeight="500"
            size="md"
            onChange={
                (e) => {
                    if(e.target.value.length > 4 && e.target.value !== '__.__') {     
                        manejoGrupo(item, e.target.value);
                    }
                }
            }
            onBlur={(e) => {
              manejoGrupo(item, e.target.value);
            }}
            as={InputMask}
            mask={"99.99"}
            disabled={item.travado}
          />
        </FormControl>
      </Box>
      <ItemTableProject
        index={index}
        borderColor={borderColor}
        changeItem={changeItem}
        item={item}
        accountSelected={accountSelected}
        key={index}
        calcula={calcula}
        calculaManejo={calculaManejo}
      />
    </Box>
  );
};
export default FinanceProjectCategory;
